import { render, staticRenderFns } from "./states-table-personalized.vue?vue&type=template&id=6b45b4f9&"
import script from "./states-table-personalized.vue?vue&type=script&lang=js&"
export * from "./states-table-personalized.vue?vue&type=script&lang=js&"
import style0 from "./states-table-personalized.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default})
